import Styled from "styled-components";

export const SignUpContainer = Styled.div`
display: flex;
flex-direction: column;
width: 380px;

h2 {
  margin: 10px 0;
}

`;

